export default __webpack_public_path__ + "static/media/profile-yh.66b4dfb5.png";